import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import EpiRepository from '@/shared/http/repositories/business/epi'
// import aprTemplateEpiRepository from '@/shared/http/repositories/business/aprTemplateEpi'

// import Tools from '@/components/tools/Tools'

export default {
  name: 'addEpiApr',
  props: ['aprId', 'revisao'],
  mixins: [ActionsForm],
  components: {},
  data () {
    return {
      Adicionar: true,
      searchEpi: null,
      cancelarEpi: false,
      dataEPI: [],
      datanewEPI: {},
      dataFiltroEPI: [],
      buscaEpi: '',
      EpiAguardandoEnvio: []
    }
  },

  watch: {
    buscaEpi (newvalue, oldvalue) {
      if (newvalue.trim() !== '') {
        this.BuscaEpiAdd(newvalue)
      } else {
        this.dataFiltroEPI = this.dataEPI
      }
    }
  },

  mounted () {
  },
  methods: {
    AdicionarEpi (id) {
      let novaEPI = {descricao: id.descricao, statusAprovacaoDescricao: 'AG. ENVIO', statusAprovacao: null, dateCricaoFormatada: null, dateCricao: null, epiId: id.id, tipoMudanca: 'INCLUSÃO AG. ENVIO', AgEnvio: true}
      this.EpiAguardandoEnvio.push(novaEPI)
      this.Adicionar = !this.Adicionar
      var div = document.getElementById(id.id)
      // Verifica se a classe 'clicked' já está presente na div
      var isClicked = div.classList.contains('clicked')
      // Se já estiver clicada, remove a classe, caso contrário, adiciona
      if (isClicked) {
        div.classList.remove('clicked')
        this.EpiAguardandoEnvio = this.EpiAguardandoEnvio.filter(epi => epi.epiId !== id.id)
      } else {
        div.classList.add('clicked')
      }
    },
    identificarElementosClicados () {
      var elementosClicados = []
      this.dataEPI.forEach(function (elemento) {
        var elementoHTML = document.getElementById(elemento.id)
        if (elementoHTML && elementoHTML.classList.contains('clicked')) {
          elementosClicados.push(elementoHTML.id)
        }
      })

      if (elementosClicados.length > 0) {
        this.addEPI(elementosClicados)
      } else {
        toast.warning('Adicione pelo menos um item')
      }
    },
    cancel () {
      this.cancelarEpi = !this.cancelarEpi
      this.$emit('cancelarEpi', this.cancelarEpi)
    },
    addEPI (ids) {
      console.log(ids)
      this.datanewEPI = {epi: ids, APRId: this.aprId}
      this.$emit('salvarEpi', this.datanewEPI)
      this.$emit('AdicionarTableEPI', this.EpiAguardandoEnvio)
    },
    onLoad () {
      loading.push()
      EpiRepository.GetEPI(this.aprId, this.revisao)
        .then((Response) => {
          loading.pop()
          this.dataEPI = Response.data.data
          this.dataFiltroEPI = Response.data.data
        }).catch(Error => {
          loading.pop()
          toast.error('Erro ao carregar as informações')
        })
    },
    BuscaEpiAdd (value) {
      this.dataFiltroEPI = this.dataEPI.filter((Element) => Element.descricao.toUpperCase().indexOf(value.toUpperCase()) > -1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/templateApr/components/addEpiApr/addEpiApr.js